import React from 'react'

import "./core-loading-animation.css"

/*

EXAMPLE

<div style={{
				width: '100px'
			}} className="center-element">
				<CoreLoadingAnimation zoom={2} type={CoreLoadingAnimationLoadingType.one}></CoreLoadingAnimation>
			</div> 

*/

const CoreLoadingAnimation = (props: CoreLoadingAnimationConfig) => {

	return (
		<div className="core-loading-animation modal-disable-select" style={{
		}}>
			{props.type === CoreLoadingAnimationLoadingType.one ? 
				<div className="core-loading-animation-load-wrap" style={{
					transform: 'scale(' + props.zoom + ')'
				}}>
					<div className="core-loading-animation-load-1">
						<div className="core-loading-animation-line"></div>
						<div className="core-loading-animation-line"></div>
						<div className="core-loading-animation-line"></div>
					</div>
				</div> : (null)}
			{props.type === CoreLoadingAnimationLoadingType.two ? 
				<div className="core-loading-animation-load-wrap" style={{
					transform: 'scale(' + props.zoom + ')'
				}}>
					<div className="core-loading-animation-load-2">
						<div className="core-loading-animation-line"></div>
						<div className="core-loading-animation-line"></div>
						<div className="core-loading-animation-line"></div>
					</div>
				</div> : (null)}
			{props.type === CoreLoadingAnimationLoadingType.three ? 
				<div className="core-loading-animation-load-wrap" style={{
					transform: 'scale(' + props.zoom + ')'
				}}>
					<div className="core-loading-animation-load-3">
						<div className="core-loading-animation-line"></div>
						<div className="core-loading-animation-line"></div>
						<div className="core-loading-animation-line"></div>
					</div>
				</div> : (null)}
			{props.type === CoreLoadingAnimationLoadingType.four ? 
				<div className="core-loading-animation-load-wrap" style={{
					transform: 'scale(' + props.zoom + ')'
				}}>
					<div className="core-loading-animation-load-4">
						<div className="core-loading-animation-ring-1"></div>
					</div>
				</div> : (null)}
			{props.type === CoreLoadingAnimationLoadingType.five ? 
				<div className="core-loading-animation-load-wrap" style={{
					transform: 'scale(' + props.zoom + ')'
				}}>
					<div className="core-loading-animation-load-5">
						<div className="core-loading-animation-ring-2">
							<div className="core-loading-animation-ball-holder">
								<div className="core-loading-animation-ball"></div>
							</div>
						</div>
					</div>
				</div> : (null)}
			{props.type === CoreLoadingAnimationLoadingType.six ? 
				<div className="core-loading-animation-load-wrap" style={{
					transform: 'scale(' + props.zoom + ')'
				}}>
					<div className="core-loading-animation-load-6">
						<div className="core-loading-animation-letter-holder">
							<div className="core-loading-animation-l-1 core-loading-animation-letter default-text">L</div>
							<div className="core-loading-animation-l-2 core-loading-animation-letter default-text">o</div>
							<div className="core-loading-animation-l-3 core-loading-animation-letter default-text">a</div>
							<div className="core-loading-animation-l-4 core-loading-animation-letter default-text">d</div>
							<div className="core-loading-animation-l-5 core-loading-animation-letter default-text">i</div>
							<div className="core-loading-animation-l-6 core-loading-animation-letter default-text">n</div>
							<div className="core-loading-animation-l-7 core-loading-animation-letter default-text">g</div>
							<div className="core-loading-animation-l-8 core-loading-animation-letter default-text">.</div>
							<div className="core-loading-animation-l-9 core-loading-animation-letter default-text">.</div>
							<div className="core-loading-animation-l-10 core-loading-animation-letter default-text">.</div>
						</div>
					</div>
				</div> : (null)}
			{props.type === CoreLoadingAnimationLoadingType.seven ? 
				<div className="core-loading-animation-load-wrap" style={{
					transform: 'scale(' + props.zoom + ')'
				}}>
					<div className="core-loading-animation-load-7">
						<div className="core-loading-animation-square-holder">
							<div className="core-loading-animation-square"></div>
						</div>
					</div>
				</div> : (null)}
			{props.type === CoreLoadingAnimationLoadingType.eight ? 
				<div className="core-loading-animation-load-wrap" style={{
					transform: 'scale(' + props.zoom + ')'
				}}>
					<div className="core-loading-animation-load-8">
						<div className="core-loading-animation-line"></div>
					</div>
				</div> : (null)}
			{props.type === CoreLoadingAnimationLoadingType.nine ? 
				<div className="core-loading-animation-load-wrap" style={{
					transform: 'scale(' + props.zoom + ')'
				}}>
					<div className="core-loading-animation-load-9">
						<div className="spinner">
							<div className="core-loading-animation-bubble-1"></div>
							<div className="core-loading-animation-bubble-2"></div>
						</div>
					</div>
				</div> : (null)}
			{props.type === CoreLoadingAnimationLoadingType.ten ? 
				<div className="core-loading-animation-load-wrap" style={{
					transform: 'scale(' + props.zoom + ')'
				}}>
					<div className="core-loading-animation-load-10">
						<div className="core-loading-animation-bar"></div>
					</div>
				</div> : (null)}
		</div>
	);

};

export interface CoreLoadingAnimationConfig {
	zoom: number;
	type: CoreLoadingAnimationLoadingType;
}

export enum CoreLoadingAnimationLoadingType {
	one,
	two,
	three,
	four,
	five,
	six,
	seven,
	eight,
	nine,
	ten
}

export default CoreLoadingAnimation;